import env from '@env'
import { getHandTopUrl } from '@dt/fe-utils'
import Config from '@common/config/config'
import { getPlatform } from '@utils'

const { isIOS, isWeixin, isAlipay, isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()

const _wxConfigG = (function () {
  let _inited = 0
  return {
    isInited: function () {
      return _inited
    },
    close: function () {
      window.WeixinJSBridge.invoke('closeWindow')
    },
    scan: function (fun) {
      const p = {
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success (res) {
          const result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          if (fun) {
            fun(result)
          }
        }
      }
      wx.scanQRCode(p)
    },
    getLocation: function (callback, failCallBack) {
      let hasSuccess = false
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          wx.getLocation({
            type: 'wgs84', // gcj02 // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              console.log('getLocation:success ', res)
              // const latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
              // const longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
              // const speed = res.speed // 速度，以米/每秒计
              // const accuracy = res.accuracy // 位置精度
              hasSuccess = true
              if (callback) {
                callback(res)
              }
              resolve(res)
            },
            fail: function (res) {
              console.log('getLocation:fail ', res)
              if (failCallBack) {
                failCallBack(res)
              }
              resolve(false)
            },
            // complete: function (res) {
            //   console.log('getLocation:complete ', res)
            //   if (!hasSuccess) {
            //     if (failCallBack) {
            //       failCallBack(res)
            //     }
            //     resolve(false)
            //   }
            // }
          })
        }, 0)
      })
    },
    hideOptionMenu: function () {
      wx.hideOptionMenu()
    },
    postMessage: function (params) {
      if (!isWeixinMiniProgram || !wx) return

      // postMessage
      wx.miniProgram.postMessage({
        data: params
      })
    },
    // cb 成功回调 failCb 失败回调
    init: function (cb, failCb) {
      const jsApiList = ['chooseWXPay', 'getLocation', 'updateAppMessageShareData', 'updateTimelineShareData', 'scanQRCode', 'openAddress', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'translateVoice', 'playVoice']
      const p = {
        brandId: Config.BRANDID,
        type: isWeixinMiniProgram ? 2 : 1,
        url: encodeURIComponent(location.href.split(location.hash || '#')[0])
      }
      if (_inited && isIOS) {
        cb && cb()
        return new Promise((resolve, reject) => {
          resolve(true)
        })
      }
      return fetch(`${env.MEMBER}/open/getJsConfig`, {
        method: 'POST',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json;charset=UTF-8',
          brandid: Config.BRANDID || ''
        },
        body: JSON.stringify(p)
      }).then(res => {
        return res.json()
      }).then(function (res) {
        if (res && res.result) {
          const data = res.result
          const configP = {
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1 jsapitk
            jsApiList: jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          }
          console.log(configP, 'configP')
          wx.config(configP)
          return new Promise((resolve, reject) => {
            wx.ready(function (res) {
              _inited = true
              console.log('wx.ready_________', configP)
              cb && cb()
              resolve(true)
            })
            wx.error(function (res) {
              console.log(configP, 'configP')
              _inited = false
              console.log('wx.error_________', res)
              failCb && failCb(res)
              resolve(false)
            })
          })
        } else {
          _inited = false
          failCb && failCb(res)
          return false
        }
      })
    },
    remove () {
    }
  }
})()

const _apConfigG = (function () {
  let _inited = false
  return {
    isInited: function () {
      return _inited
    },
    close: function () {
      function ready (callback) {
        if (window.AlipayJSBridge) {
          callback && callback()
        } else {
          document.addEventListener('AlipayJSBridgeReady', callback, false)
        }
      }
      ready(function () {
        AlipayJSBridge.call('exitApp', { closeActionType: 'exitSelf' })
      })
    },
    scan: function (fun) {
      const p = {
        type: 'qr', // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          const result = res.code
          if (fun) {
            fun(result)
          }
        }
      }
      ap.scan(p)
    },
    pay: function (tradeNO, fun, backurl) {
      if (window.ISALIPAYMINI) {
        if (my.tradePay) {
          my.tradePay({
            tradeNO: tradeNO
          }, function (result) {
            if (result.resultCode === '9000') {
              fun && fun()
            } else {
              console.error(result)
            }
          })
        } else {
          my.navigateTo({ url: '/pages/pay/index?tradeNO=' + tradeNO + '&backurl=' + encodeURIComponent(backurl) })
        }
        return
      }
      function ready (callback) {
        if (window.AlipayJSBridge) {
          callback && callback()
        } else {
          document.addEventListener('AlipayJSBridgeReady', callback, false)
        }
      }
      ready(function () {
        AlipayJSBridge.call('tradePay', {
          tradeNO: tradeNO
        }, function (result) {
          // 1. 支付成功：
          // ‘9000’：订单支付成功;
          // 2. 支付结果未知(可能已支付成功)：
          // ‘8000’：后台获取支付结果超时，暂时未拿到支付结果;
          // ‘6004’：支付过程中网络出错， 暂时未拿到支付结果;
          // 3. 支付失败或者支付中途退出：
          // ‘7001’：客户端-钱包中止快捷支付;
          // ‘6002’: 普通网络出错;
          // ‘6001’: 用户中途取消;
          // ‘4000’: 订单支付失败;
          // ‘99’: 用户点击忘记密码快捷界面退出(only iOS since 9.5);
          fun && fun(result.resultCode)
        })
      })
    },
    getLocation: function (callback, failCallBack) {
      let hasSuccess = false
      return new Promise((resolve, reject) => {
        ap.getLocation({
          type: 2,
        }, (res) => {
          if (res?.longitude) {
            hasSuccess = true
            if (callback) {
              callback(res)
            }
            resolve(res)
          } else {
            if (failCallBack) {
              failCallBack(res)
            }
            resolve(false)
          }
        })
      })
    },
    hideOptionMenu: function () {
      ap.hideOptionButton()
    },
    postMessage: function (params) {
      if (!isAliPayMiniProgram || !my) return

      // postMessage
      my.postMessage({
        data: params
      })
    },
    init (onload) {
      const alipayjssdk = document.getElementById('alipayjssdk')
      if (alipayjssdk) {
        onload && onload()
        return
      }
      const element = document.getElementsByTagName('script')[0]
      const fjs = element
      let js = element
      js = document.createElement('script')
      js.id = 'alipayjssdk'
      js.src = 'https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js'
      if (fjs && fjs.parentNode) {
        fjs.parentNode.insertBefore(js, fjs)
      } else {
        document.head.appendChild(js)
      }
      onload && (js.onload = onload)
      _inited = true
    },
    remove () {
      const element = document.getElementById('alipayjssdk')

      if (element) {
        element.parentNode.removeChild(element)
      }
    }
  }
})()

const _ggConfigG = (function () {
  let authApi = null
  return {
    init ({ appId }) {
      if (document.getElementById('google-jssdk')) return
      ((d, s, id) => {
        const fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        const js = d.createElement(s)
        js.id = id
        js.src = 'https://apis.google.com/js/platform.js?onload=init'
        fjs.parentNode.insertBefore(js, fjs)
        js.onload = () => {
          window.gapi.load('auth2', function () {
            authApi = window.gapi.auth2.init({
              client_id: appId,
              cookie_policy: 'single_host_origin',
              scope: 'profile email',
              fetch_basic_profile: true
            })
          })
        }
      })(document, 'script', 'google-jssdk')
    },
    login () {
      return new Promise((resolve, reject) => {
        authApi.signIn().then(res => {
          const profile = res.getBasicProfile()
          const auth = res.getAuthResponse()
          const payload = {
            channel: 'google',
            idToken: auth.id_token,
            name: profile.getName(),
            avatar: profile.getImageUrl(),
            email: profile.getEmail(),
            openid: res.getId()
          }
          resolve(payload)
        }, (errr) => {
          resolve(false)
        })
      })
    }
  }
})()

const _fbConfigG = (function (accessToken) {
  const getLoginInfo = (accessToken) => {
    return new Promise((resolve, reject) => {
      const fields = ['id', 'first_name', 'last_name', 'middle_name', 'name', 'name_format', 'picture', 'short_name', 'email'].join(',')
      window.FB.api(`/me?fields=${fields}`, res => {
        const payload = {
          profile: res
        }
        resolve(payload)
      })
    })
  }
  return {
    init ({ appId }) {
      if (document.getElementById('facebook-jssdk')) return
      ((d, s, id, appId) => {
        const fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        const js = d.createElement(s)
        js.async = true
        js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
        js.onload = () => {
          window.fbAsyncInit = () => {
            window.FB.init({
              appId,
              cookie: true,
              xfbml: false,
              version: 'v7.0'
            })
          }
        }
      })(document, 'script', 'facebook-jssdk', appId)
    },
    login () {
      return new Promise((resolve, reject) => {
        if (!window.FB) {
          resolve(false)
        }
        window.FB.getLoginStatus(res => {
          if (res.status === 'connected') {
            getLoginInfo().then(info => {
              resolve(info)
            })
          } else {
            FB.login(function (resp) {
              if (resp.authResponse) {
                getLoginInfo(resp.authResponse.accessToken).then(info => {
                  resolve(info)
                })
              } else {
                resolve(false)
              }
            }, { scope: 'public_profile,email' })
          }
        })
      })
    }
  }
})()

const _stripeConfigG = (function () {
  return {
    init (onload) {
      const stripejssdk = document.getElementById('stripejssdk')
      if (stripejssdk) {
        return
      }
      const element = document.getElementsByTagName('script')[0]
      const fjs = element
      let js = element
      js = document.createElement('script')
      js.id = 'stripejssdk'
      js.src = 'https://js.stripe.com/v2/'
      if (fjs && fjs.parentNode) {
        fjs.parentNode.insertBefore(js, fjs)
      } else {
        document.head.appendChild(js)
      }
      js.onload = onload
    },
    remove () {
      const element = document.getElementById('stripejssdk')

      if (element) {
        element.parentNode.removeChild(element)
      }
    },
  }
})()

const _wxpgpConfigG = (function () {
  const payurl = 'https://payapp.weixin.qq.com'
  return {
    init (onload) {
      const wxpaygpjssdk = document.getElementById('wxpay-goldplan-jssdk')
      if (wxpaygpjssdk) {
        return
      }
      const element = document.getElementsByTagName('script')[0]
      const fjs = element
      let js = element
      js = document.createElement('script')
      js.id = 'wxpay-goldplan-jssdk'
      js.src = 'https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js'
      if (fjs && fjs.parentNode) {
        fjs.parentNode.insertBefore(js, fjs)
      } else {
        document.head.appendChild(js)
      }
      js.onload = onload
    },
    remove () {
      const element = document.getElementById('wxpay-goldplan-jssdk')
      if (element) {
        element.parentNode.removeChild(element)
      }
    },
    showPage (height = 960) {
      const mchData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE',
        height: height
      }
      const postData = JSON.stringify(mchData)
      parent.postMessage(postData, payurl)
    },
    jumpOut (url) {
      const mchData = {
        action: 'jumpOut',
        jumpOutUrl: `${getHandTopUrl()}${url}`
      }
      const postData = JSON.stringify(mchData)
      parent.postMessage(postData, payurl)
    }
  }
})()

export const wxConfigG = _wxConfigG

export const apConfigG = _apConfigG

export const ggConfigG = _ggConfigG

export const fbConfigG = _fbConfigG

export const stripeConfigG = _stripeConfigG

export const wxpgpConfigG = _wxpgpConfigG

export const thirdConfigG = () => {
  return isWeixin ? wxConfigG : isAlipay ? apConfigG : null
}
